module.exports = __webpack_public_path__ + "img/gh-305em.asm.73f83b5a.jpg";